/**
 * Convert string into dot case.
 * Join punctuation with slash.
 * @memberof module:stringcase/lib
 * @function dotcase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */
'use strict';

var snakecase = require('./snakecase');
/** @lends dotcase */


function dotcase(str) {
  return snakecase(str).replace(/_/g, '.');
}

module.exports = dotcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvdGNhc2UuanMiXSwibmFtZXMiOlsic25ha2VjYXNlIiwicmVxdWlyZSIsImRvdGNhc2UiLCJzdHIiLCJyZXBsYWNlIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7O0FBU0E7O0FBRUEsSUFBTUEsU0FBUyxHQUFHQyxPQUFPLENBQUMsYUFBRCxDQUF6QjtBQUVBOzs7QUFDQSxTQUFTQyxPQUFULENBQWtCQyxHQUFsQixFQUF1QjtBQUNyQixTQUFPSCxTQUFTLENBQUNHLEdBQUQsQ0FBVCxDQUFlQyxPQUFmLENBQXVCLElBQXZCLEVBQTZCLEdBQTdCLENBQVA7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCSixPQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gZG90IGNhc2UuXG4gKiBKb2luIHB1bmN0dWF0aW9uIHdpdGggc2xhc2guXG4gKiBAbWVtYmVyb2YgbW9kdWxlOnN0cmluZ2Nhc2UvbGliXG4gKiBAZnVuY3Rpb24gZG90Y2FzZVxuICogQHBhcmFtIHtzdHJpbmd9IHN0ciAtIFN0cmluZyB0byBjb252ZXJ0LlxuICogQHJldHVybnMge3N0cmluZ30gUGF0aCBjYXNlZCBzdHJpbmcuXG4gKi9cblxuJ3VzZSBzdHJpY3QnXG5cbmNvbnN0IHNuYWtlY2FzZSA9IHJlcXVpcmUoJy4vc25ha2VjYXNlJylcblxuLyoqIEBsZW5kcyBkb3RjYXNlICovXG5mdW5jdGlvbiBkb3RjYXNlIChzdHIpIHtcbiAgcmV0dXJuIHNuYWtlY2FzZShzdHIpLnJlcGxhY2UoL18vZywgJy4nKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IGRvdGNhc2VcbiJdfQ==